<template>
  <div class="overall-bg pt-3 pb-0">
    <b-container>
      <b-row>
        <b-col>
          <BackToMasters :goback="$router.back"></BackToMasters>
          <Headerlayout :headertext="$t('PurchaseIndent.title')" :contenttext="$t('PurchaseIndent.contents')">
          </Headerlayout>
        </b-col>
      </b-row>
    </b-container>
  </div>
  <div class="overall-bg p-0">
    <b-container>
      <div class="form-white-bg">
        <b-row>
          <b-row>
            <b-col lg="3" md="4" sm="6">
              <div class="field">
                <label>PI</label>
                <!-- <TextField v-model="ObjVal.DocNo" type="text" placeholder="Enter manufaturer Id" clearable disabled
                name="" /> -->
                <p>{{ ObjVal.DocNo }}</p>
              </div>
            </b-col>
          </b-row>
          <b-row>
            <b-col lg="3" md="4" sm="6">
              <div class="nolabel">
                <div class="field" v-if="requestdropdown">
                  <label class="requestlabel">{{
                    $t("Request.requestid")
                  }}</label>
                  <CustomMultiSelect placeholder="Select Request Id" v-model="requestid.RequestIDValue"
                    :items="requestid.RequestIDOptions" @update:modelValue="RequestIDOnChange" ref="multiRef"
                    @blur="onDropdownBlur" />
                </div>
              </div>
              <div class="d-flex field" v-if="requestValue">
                <div class="common-heading">{{ requestidValue }}</div>
                <div class="ps-3">
                  <EditIcon />
                </div>
              </div>
            </b-col>
            <b-col lg="6" md="4" sm="6" cols="12" class="d-flex">
              <div class="field">
                <label>{{ $t("Request.uploadquotation") }}</label>
                <input type="file" :multiple="true" id="actual-btn" @change="handleChangedocument" ref="fileInput"
                  style="display: none" />
                <label id="custom-btn" for="actual-btn" class="flbtn">
                  <i class="pi pi-upload" style="color: slateblue"></i>
                  Choose File</label>
              </div>
            </b-col>
          </b-row>
          <b-row>
            <b-col lg="3" md="4" sm="6" cols="12" class="d-flex" v-for="item in uploadedTableList">
              <div class="fileuploadcard my-2" :title="item.fileName">
                <div>
                  <p class="filenametxt">{{ item.fileName }}</p>
                  <div class="blue-txt" id="file-name" @click="fileviewer(item.fullPath)">
                    view
                  </div>
                </div>
                <DeleteIcon @click="fileuploadDelete(item)" />
              </div>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <TabView class="tabview-custom" ref="tabview4" v-model:activeIndex="clases.ItemsReOrderTab">
                <TabPanel>
                  <template #header>
                    <i class="pi pi-align-left ps-3"></i>
                    <span>Items</span>
                  </template>
                  <div>
                    <b-row>
                      <b-col class="d-flex flex-row-reverse pt-3">
                        <p class="add-items d-flex d-flex-row-reverse" v-b-toggle.collapse-3>
                          + Add New
                        </p>
                      </b-col>
                    </b-row>
                    <b-row>
                      <b-col>
                        <b-collapse id="collapse-3" :class="displayClass">
                          <Item @additemclick="AddItems" v-model:data-items="dataItems" :show-fields="showFields"
                            :addItemData="items" :commonItemProps="commonItemProps" @calculation="TotalGrossCalc"
                            :requestdata="requestdata" @clearitem="clearItems" />
                        </b-collapse>
                      </b-col>
                    </b-row>

                    <TabView class="tabview-custom" ref="tabview4" v-model:activeIndex="clases.WithAndWithoutRateTab">
                      <TabPanel>
                        <template #header>
                          <i class="pi pi-align-left pe-3"></i>
                          <span>With Rate Contract</span>
                        </template>

                        <p>
                          <ETableview :rowHover="true" filterDisplay="menu" :loading="loading" responsiveLayout="scroll"
                            :columns="headers" :globalFilterFields="globalFilterFields" :data="WithRateContractTable"
                            :seriaNlumber="true">
                            <template v-slot:Add>
                              <span>
                                <AddButton :btnname="$t('btn.plusaddnew')"></AddButton>
                              </span>
                            </template>
                            <template v-slot:field>
                              <span>
                                <AddButton :btnname="$t('btn.plusaddnew')"></AddButton>
                              </span>
                            </template>
                            <template v-slot:SupplierIdwr="{ data }">
                              <div class="label-d-none tablefield mb-0" @click="isfilterSupplier(data)">
                                <!-- @change="isfilterSupplier(data)" -->
                                <Dropdown :items="data.SupplierOptions" v-model="data.supplierId"
                                  @update:modelValue="GetSupplierData(data)">
                                </Dropdown>
                              </div>
                            </template>
                            <template v-slot:StockInHand="{ data }">
                              {{
                                data.StockInHand -
                                (data.PickedQty + data.InTransist)
                              }}
                            </template>
                            <template v-slot:action="{ data }">
                              <span>
                                <EditIcon @click="IsItemEdit(data)" />
                                <DeleteIcon @click="IsItemDelete(data)" />
                              </span>
                            </template>
                          </ETableview>

                          <b-row>
                            <b-col class="d-flex flex-row-reverse">
                              <AddButton btnname="Send for PO" @click="IsSubmit()" />
                              <cancel @canclebtn="$emit('cancel')" />
                            </b-col>
                          </b-row>
                        </p>
                      </TabPanel>
                      <TabPanel>
                        <template #header>
                          <i class="pi pi-shopping-bag pe-3"></i>
                          <span>Without Rate Contract</span>
                        </template>
                        <p>
                          <ETableview :rowHover="true" filterDisplay="menu" :loading="loading" responsiveLayout="scroll"
                            :columns="WORateHeaders" :globalFilterFields="globalFilterFields"
                            :data="WithoutRateContractTable" :seriaNlumber="true">
                            <template v-slot:Add>
                              <span>
                                <AddButton :btnname="$t('btn.plusaddnew')"></AddButton>
                              </span>
                            </template>
                            <template v-slot:SupplierIdwor="{ data }">
                              <div class="label-d-none tablefield mb-0" @click="filterSupplierByCategory(data)">
                                <CustomMultiSelect :items="data.SupplierOptionsWOR" v-model="data.supplierIdwo">
                                </CustomMultiSelect>
                              </div>
                            </template>
                            <template v-slot:StockInHand="{ data }">
                              {{
                                data.StockInHand -
                                (data.PickedQty + data.InTransist)
                              }}
                            </template>

                            <template v-slot:action="{ data }">
                              <span>
                                <EditIcon @click="IsItemEdit(data)" />
                                <DeleteIcon @click="IsItemDelete1(data)" />
                              </span>
                            </template>
                          </ETableview>
                          <b-row>
                            <b-col class="d-flex flex-row-reverse">
                              <AddButton btnname="Send for Quote" @click="IsSubmitQuote()" />
                              <cancel @canclebtn="$emit('cancel')" />
                            </b-col>
                          </b-row>
                        </p>
                      </TabPanel>
                    </TabView>
                  </div>
                </TabPanel>
                <TabPanel>
                  <template #header>
                    <i class="pi pi-shopping-bag pe-3"></i>
                    <span>Items below reorder level </span>
                  </template>
                  <p>
                    <AddItemsVue @AddSingleClick="AddSingleConfirmation('Single')"
                      @SelectAll="AddAllConfirmation('All')" />
                    <NTableview :rowHover="true" filterDisplay="menu" :loading="loading" responsiveLayout="scroll"
                      :columns="ReOrderheaders" :data="ReOrderData" v-model:selection="selectedProduct"
                      :selectionMode="true">
                      <!-- <template v-slot:Add>
                      <span>
                        <AddButton :btnname=" $t('btn.plusaddnew')"></AddButton>
                      </span>
                    </template> -->
                      <template v-slot:Brandmodelsize="{ data }">
                        <p>
                          <span v-if="data.BrandName">{{ data.BrandName }} </span><span v-if="data.ModelNumberName">/{{
                            data.ModelNumberName }} </span><span v-if="data.SizeName">/{{ data.SizeName }}</span>
                        </p>
                      </template>
                      <template v-slot:action="{ data }">
                        <span>
                          <!-- <EditIcon @click="IsItemEdit(data)" /> -->
                          <DeleteIcon @click="IsReOrderDelete(data)" />
                        </span>
                      </template>
                    </NTableview>
                  </p>
                </TabPanel>
              </TabView>
            </b-col>
          </b-row>
        </b-row>
      </div>
    </b-container>
  </div>
  <CreateSuccessully :visible="successpop" @ok="closetrigger()" />
  <UpdatedSuccessfully :visible="updatepop" @ok="closetrigger()" />
  <AddItemConfirmation :Editmodel="AddItemmodel" @yes="CopyReorderData(confirmval)" @no="AddItemmodel = false"
    :content="msgcontent" />
  <WarningMessage :visible="wariningPopup" :content="warningmsgcontent.warningcontent" @ok="ClosewariningPopup()" />
  <QuoteConfirmation :Editmodel="IsQuoteModel" @yes="IsQuote()" @no="IsQuoteClose()"
    content="$t('confirmation.doyouwanttogeneratequote')" />
  <PIConfirmation :Editmodel="IsPIModel" @yes="IsPI()" @no="IsPIClose()"
    content="$t('confirmation.doyouwanttogeneratepo')" />
  <CrystalReportPrintPopUp :ShowAndHide="CrystalReportPopup" :ParameterValues="ParameterValues"
    :PrintType="PrintType" />
  <Toast />
</template>
<script lang="ts">
import BackToMasters from "../../../../components/FormComponents/BacktoMaster.vue";
import Dropdown from "../../../../components/FormComponents/Dropdown.vue";
import Headerlayout from "../../../../components/Masters/HeaderLayout.vue";
import Badge from "primevue/badge";
import AddItemsVue from "../../../../modules/Inventory/components/Transaction/AddItems.vue";
import { defineComponent, ref, computed, onMounted, reactive } from "vue";
import NTableview from "../../../../components/FormComponents/NormalTable.vue";
import ETableview from "../../../../components/FormComponents/EditableTable.vue";
import { FilterMatchMode, FilterOperator } from "primevue/api";
import Item from "../../../../modules/Inventory/components/Transaction/Item.vue";
import { useRoute, useRouter } from "vue-router";
import Footer from "../../../../components/FormComponents/Footer.vue";
import cancel from "../../../../components/GeneralButtons/CancelButtton.vue";
import TextField from "../../../../components/FormComponents/TextInput.vue";
import CustomMultiSelect from "../../../../components/FormComponents/MultiSelectDropdown.vue";
import common from "../../../Inventory/Service/CommonService";
import WithoutStockService from "../../../Inventory/Service/WithoutStockAffectService";
import CreateSuccessully from "../../../../components/FormComponents/createdsuccessfully.vue";
import UpdatedSuccessfully from "../../../../components/FormComponents/UpdatedSuccessfully.vue";
import AddItemConfirmation from "../../../../components/FormComponents/AddItemsConfirmation.vue";
import WarningMessage from "../../../../components/FormComponents/WarningMessage.vue";
import SupllierService from "../../../Inventory/Service/SupplierMaster";
import RateContractService from "../../../../modules/Inventory/Service/RateContractService";
import SupplierCategoryService from "../../../../modules/Inventory/Service/SupplierCategoryMappingService";
import QuoteConfirmation from "../../../../components/FormComponents/EditConfirmation.vue";
import PIConfirmation from "../../../../components/FormComponents/EditConfirmation.vue";
import GetSupplierDataService from "../../Service/SupplierMaster";
import { useToast } from "primevue/usetoast";
import moment from "moment";
import CrystalReportPrintPopUp from "../../../../modules/Inventory/components/Print/CrystalReportPrint.vue";
import { setupHistoryManagement } from "../../../../modules/Inventory/Service/HistoryManage";
import { useI18n } from "vue-i18n";
import { useForm } from "vee-validate";
import StockWOFileUploadServices from "../../../../modules/Inventory/Service/StockWOFileUploadService";

export default defineComponent({
  components: {
    Badge,
    AddItemsVue,
    Item,
    ETableview,
    NTableview,
    Footer,
    cancel,
    BackToMasters,
    Headerlayout,
    TextField,
    CustomMultiSelect,
    CreateSuccessully,
    UpdatedSuccessfully,
    AddItemConfirmation,
    WarningMessage,
    Dropdown,
    QuoteConfirmation,
    PIConfirmation,
    CrystalReportPrintPopUp,
  },
  props: {
    showone: {
      type: String,
      default: "",
    },
  },
  setup(props, { emit }) {
    debugger;
    //Session Hospital&Branch ID
    let session: any = localStorage.getItem("UsersData");
    const { handleSubmit, errors, resetForm, resetField } = useForm();
    const routes = useRoute();
    const { t } = useI18n();
    session = JSON.parse(session);
    let HospitalId = Number(session.OrganizationId);
    let BranchId = Number(session.BranchId);
    let UserId = Number(session.UserId);
    //let items = ref([]);
    const toast = useToast();
    let List = ref([]);
    let loading = ref(false);
    let showitemfield = ref(false);
    const items: any = ref([]);
    const displayClass = ref("");
    const WithoutRateContractTable: any = ref([]);
    const WithRateContractTable: any = ref([]);
    let requestdata: any = ref();
    const ReOrderData: any = ref([]);
    const router = useRouter();
    const successpop = ref(false);
    const updatepop = ref(false);
    const AddItemmodel = ref(false);
    const wariningPopup = ref(false);
    const selectedProduct: any = ref([]);
    let requestdropdown = ref(true);
    let requestValue = ref(false);
    let requestidValue = ref("");
    const multiRef = ref<HTMLElement | null>(null);
    const CrystalReportPopup = ref(false);
    let StoreBranchMapId = Number(
      JSON.parse(String(routes.query.data)).StoreBrMapId ?? 0
    );
    let dupitems: any = ref([]);
    let EditFlag = 0;
    let QueryStringValue: any = routes.query;
    QueryStringValue = JSON.parse(QueryStringValue.data);
    let IsDraftFlag = QueryStringValue["IsDraft"];

    const commonItemProps = ref({
      storeId: "",
      type: 0,
    });
    // let clases = ref(0);
    let clases = ref({
      ItemsReOrderTab: 0,
      WithAndWithoutRateTab: 0,
    });

    let fullPath = ref();
    let uploadedTableList: any = ref([]);
    let DeletedFileUpload: any = [];
    const StockWOFileUpload = ref([]);

    // For Get Current date and time in sql server format
    const now = new Date();
    const year = now.getFullYear();
    const month = now.getMonth() + 1;
    const day = now.getDate();
    const hours = now.getHours();
    const minutes = now.getMinutes();
    const seconds = now.getSeconds();
    const milliseconds = now.getMilliseconds();

    const formattedDate = `${year}-${month.toString().padStart(2, "0")}-${day
      .toString()
      .padStart(2, "0")}T${hours.toString().padStart(2, "0")}:${minutes
        .toString()
        .padStart(2, "0")}:${seconds.toString().padStart(2, "0")}.${milliseconds
          .toString()
          .padStart(3, "0")}`;
    // end
    const ObjVal = ref({
      Id: 0,
      DocType: "",
      DocNo: "",
      //DocDate: "2023-03-15T13:40:56.139Z",
      DocDate: formattedDate,
      RefId: 0,
      RefNo: "",
      StoreId: 0,
      CreatedAt: "",
      CreatedBy: 0,
      ModifiedAt: "",
      ModifiedBy: 0,
      HospitalId: 0,
      BranchId: 0,
      SupplierId: 0,
      Amount: 0.0,
      EntityId: 0,
      EntityOperationId: 0,
      StoreBrMapId: 0,
      IsDraft: 0,
      StockWODetailList: [],
    });

    const grossvalues = ref({
      grossamount: 0.0,
      taxamount: 0.0,
      totaldiscountamount: 0.0,
      transportcharges: 0.0,
      servicecharges: 0.0,
      othercharges: 0.0,
      netamount: 0.0,
      totalqty: 0.0,
    });

    // let showFields = {
    //   Category: true,
    //   Name: true,
    //   Batch: false,
    //   PackSize: true,
    //   UnitRate: true,
    //   Qty: true,
    //   MRP: false,
    //   Discount: false,
    // };
    let showFields = {
      // Category: true,
      Name: {
        show: true,
        require: true,
      },
      Batch: {
        show: false,
        require: false,
      },
      PackSize: {
        show: true,
        require: true,
      },
      UnitRate: {
        show: true,
        require: true,
      },
      Qty: {
        show: true,
        require: true,
      },
      // MRP: false,
      //  Discount: false,
      AvailQty: {
        show: false,
        require: false,
      },
      IssuedQty: {
        show: false,
        require: false,
      },
      RequestedQty: {
        show: false,
        require: false,
      },
    };

    function ShowItems() {
      showitemfield.value = true;
    }

    const headers = [
      {
        header: t("storetabdetails.picreationtable.Category"),
        field: "ItemCategory1",
        class: "smallwidth",
      },
      {
        header: t("storetabdetails.picreationtable.Code"),
        field: "ItemProductId",
        class: "smallwidth",
      },
      // {
      //   header: "HSN Code",
      //   field: "HSNCode",
      // },
      {
        header: t("storetabdetails.picreationtable.Name"),
        field: "Itemname1",
        bodyclass: "boldclass text_overflow2",
        class: "mediumwidth",
      },
      {
        header: t("storetabdetails.picreationtable.AvlQty"),
        // field: "StockInHand",
        slot: "StockInHand",
        fieldDisplay: "false",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        bodyclass: "right_td",
        class: "smallwidth",
      },
      {
        header: t("storetabdetails.picreationtable.PickedQty"),
        field: "PickedQty",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        bodyclass: "right_td",
        class: "smallwidth",
      },
      {
        header: t("storetabdetails.picreationtable.InTransist"),
        field: "InTransist",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        bodyclass: "right_td",
        class: "smallwidth",
      },
      {
        header: t("storetabdetails.picreationtable.Reorderlevel"),
        field: "ReOrderLevel",
        bodyclass: "right_td",
        class: "smallwidth",
      },
      {
        header: t("storetabdetails.picreationtable.RequiredQty"),
        field: "RequiredQuantity",
        bodyclass: "right_td",
        class: "smallwidth",
      },
      {
        header: t("storetabdetails.picreationtable.ReqQty"),
        field: "ItemQuantity",
        bodyclass: "right_td",
        class: "smallwidth",

        // editable: true,
        // type: "InputText",
      },
      {
        header: t("storetabdetails.picreationtable.ChooseSupplier"),
        field: "SupplierIdwr",
        slot: "SupplierIdwr",

        // class: "smallwidth",
      },
      // {
      //   header: "Per Unit Landing Cost",
      //   field: "",
      // },
      {
        header: t("storetabdetails.picreationtable.PaymentTerms"),
        field: "PaymentTermsDesc",

        class: "smallwidth",
      },
      {
        header: t("storetabdetails.picreationtable.DeliveryTerms"),
        field: "DeliTermsDesc",
        class: "smallwidth",
      },

      {
        class: "filterdisplaynone columnfreeze",
        fieldDisplay: "false",
        field: "action",
        header: "",
        slot: "action",
        frozencolumn: true,
        sortable: false,
      },
    ];

    const WORateHeaders = [
      // {
      //   header: "Request Id",
      //   field: "DocNo",
      // },
      {
        header: t("storetabdetails.picreationtable.Category"),
        field: "ItemCategory1",
        class: "smallwidth",
      },
      {
        header: t("storetabdetails.picreationtable.Code"),
        field: "ItemProductId",
        class: "smallwidth",
      },
      // {
      //   header: "HSN Code",
      //   field: "HSNCode",
      // },
      {
        header: t("storetabdetails.picreationtable.Name"),
        field: "Itemname1",
        bodyclass: "boldclass text_overflow2",
        class: "mediumwidth",
      },
      {
        header: t("storetabdetails.picreationtable.AvlQty"),
        //field: "StockInHand",
        slot: "StockInHand",
        fieldDisplay: "false",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        bodyclass: "right_td",
        class: "smallwidth",
      },
      {
        header: t("storetabdetails.picreationtable.PickedQty"),
        field: "PickedQty",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        bodyclass: "right_td",
        class: "smallwidth",
      },
      {
        header: t("storetabdetails.picreationtable.InTransist"),
        field: "InTransist",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        bodyclass: "right_td",
        class: "smallwidth",
      },
      {
        header: t("storetabdetails.picreationtable.Reorderlevel"),
        field: "ReOrderLevel",
        bodyclass: "right_td",
        class: "smallwidth",
      },
      {
        header: t("storetabdetails.picreationtable.RequiredQty"),
        field: "RequiredQuantity",

        bodyclass: "right_td",
        class: "smallwidth",
      },
      {
        header: t("storetabdetails.picreationtable.ReqQty"),
        field: "ItemQuantity",
        bodyclass: "right_td",
        class: "smallwidth",
        // editable: true,
        // type: "InputText",
      },
      {
        header: t("storetabdetails.picreationtable.ChooseSupplier"),
        field: "SupplierIdwor",
        slot: "SupplierIdwor",
        class: "mediumwidth",
      },
      // {
      //   header: "Per Unit Landing Cost",
      //   field: "",
      // },
      {
        field: "action",
        header: "",
        class: "filterdisplaynone columnfreeze",
        fieldDisplay: "false",
        slot: "action",
        frozencolumn: true,
        sortable: false,
      },
    ];

    //ReOrder Level Table
    const ReOrderheaders = [
      {
        header: t("storetabdetails.picreationtable.Category"),
        field: "ItemCategory1",
        class: "smallwidth",
      },
      {
        header: t("storetabdetails.picreationtable.Code"),
        field: "ItemProductId",
        class: "smallwidth",
      },
      // {
      //   header: "HSN Code",
      //   field: "HSNCode",
      // },
      {
        header: t("storetabdetails.picreationtable.Name"),
        field: "Itemname1",
        bodyclass: "boldclass text_overflow2",
        class: "mediumwidth",
      },

      {
        header: t("storetabdetails.picreationtable.Brand/Model/Size"),
        field: "",
        slot: "Brandmodelsize",
        fieldDisplay: "false",
        // bodyclass: "right_td",
      },
      {
        header: t("storetabdetails.picreationtable.ReqQty"),
        field: "ItemQuantity",
        bodyclass: "right_td",
        class: "smallwidth",

        // editable: true,
        // type: "InputText",
      },
      {
        header: t("storetabdetails.picreationtable.LPOSupplier"),
        field: "LPOSupplierName",
        bodyclass: "text_overflow2",

        class: "smallwidth",
      },
      {
        header: t("storetabdetails.picreationtable.LPODate"),
        field: "LPODate",
        // slot: "SizeIdLPO",
        bodyclass: "right_td",
        class: "smallwidth",
      },
      {
        header: t("storetabdetails.picreationtable.AvlQty"),
        field: "PurchaseUnitName",
        // slot: "SizeIdLPO",
        class: "smallwidth",
      },

      {
        header: t("storetabdetails.picreationtable.UOM"),
        field: "StockInHand",
        bodyclass: "right_td",
        class: "smallwidth",
      },

      {
        header: t("storetabdetails.picreationtable.Min"),
        field: "MinReOrderLevel",
        bodyclass: "right_td",
        class: "smallwidth",
      },
      {
        header: t("storetabdetails.picreationtable.Mix"),
        field: "MaxReOrderLevel",
        bodyclass: "right_td",
        class: "smallwidth",
      },
      {
        header: t("storetabdetails.picreationtable.Consumption"),
        field: "Consumption",
        bodyclass: "right_td",
        class: "smallwidth",
      },
      {
        header: t("storetabdetails.picreationtable.Reorder"),
        field: "ReOrderLevel",
        bodyclass: "right_td",

        class: "smallwidth",
      },
      // {
      //   header: "Choose Supplier",
      //   field: "SupplierIdwr",
      //   slot: "SupplierIdwr",

      //   // class: "smallwidth",
      // },
      // {
      //   header: "Per Unit Landing Cost",
      //   field: "",
      // },
      // {
      //   header: "Payment Terms",
      //   field: "PaymentTermsDesc",

      //   class: "smallwidth",
      // },
      // {
      //   header: "Delivery Terms",
      //   field: "DeliTermsDesc",
      //   class: "smallwidth",
      // },

      // {
      //   class: "filterdisplaynone last-column-position",
      //   fieldDisplay: "false",
      //   field: "action",
      //   header: "",
      //   slot: "action",
      //   frozencolumn: true,
      //   sortable: false,
      // },
    ];

    const route = useRoute();

    const paramValue = computed(() => {
      return route.query.param as string;
    });
    const globalFilterFields = ref(headers.map((col) => col.field));
    const filters = {
      global: { value: null, matchMode: FilterMatchMode.CONTAINS },
      Name: {
        operator: FilterOperator.AND,
        constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }],
      },
      CreatedAt: {
        operator: FilterOperator.AND,
        constraints: [{ value: null, matchMode: FilterMatchMode.DATE_IS }],
      },
      Code: {
        operator: FilterOperator.AND,
        constraints: [{ value: null, matchMode: FilterMatchMode.EQUALS }],
      },
      length: {
        operator: FilterOperator.OR,
        constraints: [{ value: null, matchMode: FilterMatchMode.EQUALS }],
      },
    };

    const AddData = ref<string[]>([]);

    const handleValues = (valuesArray: string[]) => {
      debugger;
      AddData.value = valuesArray;
      console.log(AddData.value);
    };

    onMounted(() => {
      debugger;
      ReadyFuntion();
      LoadRequestID();
      LoadReOrderLevel();
    });

    let QueryStringValue3: any = route.query;
    QueryStringValue3 = JSON.parse(QueryStringValue3.data);
    let StoreID = QueryStringValue3["StoreId"];
    let StockWoTransTMId = QueryStringValue3["StockWoTransTMId"];
    commonItemProps.value.storeId = QueryStringValue3["StoreId"];
    let Entitydata = ref();
    //Entitydata.value = localStorage.getItem("EntityData");
    Entitydata.value = Number(QueryStringValue3.EntityId) ?? 0;
    let OperationId = Number(QueryStringValue3.OperationId) ?? 0;
    let queryBranchId = QueryStringValue3["BranchId"] ?? 0;

    function ReadyFuntion() {
      debugger;
      let QueryStringValue1: any = route.query;
      QueryStringValue1 = JSON.parse(QueryStringValue1.data);

      if (QueryStringValue1["DocNo"] == "") {
        GetCode();
      } else {
        ObjVal.value.DocNo = QueryStringValue1["DocNo"];
      }

      if (QueryStringValue1["StockWoTransTMId"] != "0") {
        IsShowByStockTransId(QueryStringValue1["StockWoTransTMId"]);
      }
      LoadSuppliers();
    }

    const SuppliersWR = ref({
      SupplierOptions: [],
      supplierId: "",
    });

    const SuppliersWOR = ref({
      SupplierOptions: [],
      supplierId: "",
    });
    // Load Suppliers
    async function LoadSuppliers() {
      debugger;

      const result = await SupllierService.gettable();
      console.log(result);

      SuppliersWR.value.SupplierOptions = result["result"].map((item) => {
        item.name = item.Name;
        item.value = item.Id;
        return item;
      });

      SuppliersWOR.value.SupplierOptions = result["result"].map((item) => {
        item.name = item.Name;
        item.value = item.Id;
        return item;
      });
    }

    async function GetSupplierData(data) {
      debugger;
      try {
        let supplierId = data.supplierId;

        let response = await GetSupplierDataService.EditData(supplierId);

        let PaymentTermsDesc = response["result"][0]["PaymentTermsDesc"];
        let DeliTermsDesc = response["result"][0]["DeliTermsDesc"];

        let arr: any = ref([]);
        arr.value.push(data);

        Object.values(WithRateContractTable.value).forEach((item1: any) => {
          Object.values(arr.value).forEach((items: any) => {
            if (item1.ItemId == items.ItemId) {
              item1.PaymentTermsDesc = PaymentTermsDesc;
              item1.DeliTermsDesc = DeliTermsDesc;
            }
          });
        });
      } catch (error) {
        console.log(error);
      }
    }

    async function isfilterSupplier(data) {
      debugger;
      console.log(data);
      const response = await RateContractService.getByItemId(data.ItemId);
      if (response["result"].length > 0) {
        let arr = response["result"].map((item) => item.SupplierId);

        data.SupplierOptions = SuppliersWR.value.SupplierOptions.filter(
          (item: any) => arr.includes(item.Id)
        );
      }
    }

    async function filterSupplierByCategory(data1) {
      debugger;
      console.log(data1);
      const response = await SupplierCategoryService.GetSupplierByCategory(
        data1.CategoryId
      );
      if (response["result"].length > 0) {
        let arr = response["result"].map((item) => item.SupplierId);
        data1.SupplierOptionsWOR = SuppliersWR.value.SupplierOptions.filter(
          (item: any) => arr.includes(item.Id)
        );
      }
    }

    //Get Code
    async function GetCode() {
      debugger;
      let data = {
        // FormId: 26,
        EntityId: Entitydata.value,
        HospitalId: HospitalId,
        BranchId: queryBranchId,
        StoreId: StoreID ?? 0,
      };
      let result: any = await common.getCodeTemplate(data);
      console.log(result);

      ObjVal.value.DocNo = result;
    }

    const requestid = ref({
      RequestIDOptions: [],
      RequestIDValue: "",
    });

    // Load Request Id
    async function LoadRequestID() {
      debugger;
      let PValues = ref({
        statusValue: "0",
        DocType: 1,
      });

      const result = await WithoutStockService.GetRequestIDs(
        StoreID,
        "TS",
        PValues.value.statusValue,
        PValues.value.DocType,
        StoreBranchMapId
      );
      console.log(result);

      requestid.value.RequestIDOptions = result["result"].map((item) => {
        item.name = item.DocNo + " / " + item.DocDateHR;
        item.value = item.Id;
        return item;
      });
      console.log(requestid.value.RequestIDOptions);
    }

    // //Request Id OnChange
    // let RequestNo = "";
    // let RequestId = "";
    // let SavingArray: any = ref([]);
    // async function RequestIDOnChange(requestId) {
    //   debugger;

    //   let nonExistingValues = requestId.filter(
    //     (item) => !SavingArray.value.includes(item)
    //   );

    //   // RequestId = requestId.toString();
    //   RequestId = nonExistingValues.toString();

    //   //RequestNo = requestId.originalEvent.currentTarget.ariaLabel;
    //   console.log(RequestId);
    //   if (RequestId != "") {
    //     const result = await WithoutStockService.GetRequestedItems(RequestId);

    //     SavingArray.value = requestId;

    //     console.log(result["result"].length);

    //     Object.values(result["result"]).forEach((items: any) => {
    //       items.RequiredQuantity =
    //         Number(items.ReOrderLevel) - Number(items.StockInHand);
    //     });

    //     if (result["result"].length > 0) {
    //       Object.values(items.value).forEach((item1: any) => {
    //         Object.values(result["result"]).forEach((items: any) => {
    //           if (item1.ItemId == items.ItemId) {
    //             item1.ItemQuantity =
    //               Number(item1.ItemQuantity) + Number(items.ItemQuantity);
    //           }
    //         });
    //       });
    //       result["result"] = result["result"].filter(
    //         (value) => !items.value.some((i1) => i1.ItemId == value.ItemId)
    //       );
    //       for (let i = 0; i < result["result"].length; i++) {
    //         let obj = {};
    //         Object.assign(obj, result["result"][i]);
    //         console.log(obj);
    //         items.value.push(obj);
    //       }

    //       WithoutRateContractTable.value = items.value;
    //       WithRateContractTable.value = items.value.filter(
    //         (item) => Number(item.RateContractCount) > 0
    //       );
    //     }
    //     let arr = requestid.value.RequestIDOptions.filter((item: any) =>
    //       requestid.value.RequestIDValue.includes(item.value)
    //     );
    //     let arr1 = arr.map((item: any) => item.name).toString();
    //     console.log(arr1);
    //     requestidValue.value = arr1;
    //     // requestdropdown.value = false
    //     // requestValue.value = true
    //   }
    // }

    //Request Id OnChange
    let RequestNo = "";
    let RequestId = "";
    let SavingArray: any = ref([]);
    let SavingTableArray: any = ref([]);

    async function RequestIDOnChange(requestId) {
      debugger;

      let nonExistingValues = requestId.filter(
        (item) => !SavingArray.value.includes(item)
      );

      //  const newArray = array.filter((item) => item.id !== idToRemove);

      // RequestId = requestId.toString();
      RequestId = nonExistingValues.toString();

      //RequestNo = requestId.originalEvent.currentTarget.ariaLabel;
      console.log(RequestId);
      if (RequestId != "") {
        const result = await WithoutStockService.GetItemsByRequstIdForPIPR(
          RequestId
        );

        SavingArray.value = requestId;

        console.log(result["result"].length);

        Object.values(result["result"]).forEach((items: any) => {
          items.RequiredQuantity =
            Number(items.ReOrderLevel) - Number(items.StockInHand);
        });

        if (result["result"].length > 0) {
          Object.values(items.value).forEach((item1: any) => {
            Object.values(result["result"]).forEach((items: any) => {
              if (item1.ItemId == items.ItemId) {
                item1.ItemQuantity =
                  Number(item1.ItemQuantity) + Number(items.ItemQuantity);
              }
            });
          });
          result["result"] = result["result"].filter(
            (value) => !items.value.some((i1) => i1.ItemId == value.ItemId)
          );
          for (let i = 0; i < result["result"].length; i++) {
            let obj = {};
            Object.assign(obj, result["result"][i]);
            console.log(obj);
            items.value.push(obj);
          }

          requestdata.value = items.value;
          WithoutRateContractTable.value = items.value;
          WithRateContractTable.value = items.value.filter(
            (item) => Number(item.RateContractCount) > 0
          );
          dupitems.value = items.value;
        }
        let arr = requestid.value.RequestIDOptions.filter((item: any) =>
          requestid.value.RequestIDValue.includes(item.value)
        );
        let arr1 = arr.map((item: any) => item.name).toString();
        console.log(arr1);
        requestidValue.value = arr1;
        // requestdropdown.value = false
        // requestValue.value = true
      }
      if (dupitems.value.length > 0) {
        IsSubmitDraft();
      }
    }

    const AddItems = async (value) => {
      debugger;
      console.log(value);
      dupitems.value = [];
      WithoutRateContractTable.value = value;
      items.value = value;
      WithRateContractTable.value = value.filter(
        (item) => Number(item.RateContractCount) > 0
      );
      const lastIndex = Number(WithoutRateContractTable.value.length - 1);
      dupitems.value.push(WithoutRateContractTable.value[lastIndex]);
      await IsSubmitDraft();
    };
    function clearItems(value1) {
      debugger;
      //alert(JSON.stringify(dataItems.value))
      if (EditFlag == 1) {
        if (WithRateContractTable.value.length != 0) {
          IsSubmit();
        } else if (WithoutRateContractTable.value.length != 0) {
          IsSubmitQuote();
        }
      }

      if (EditFlag != 1) {
        dataItems.value = {};
      }
    }
    //Load Items by StockWoTrans Id
    async function IsShowByStockTransId(StockTransTMId) {
      debugger;
      const result = await WithoutStockService.GetByStockWOTransId(
        StockTransTMId
      );
      // alert(JSON.stringify(result["result"]));
      items.value = result["result"];
      WithoutRateContractTable.value = result["result"];
      WithoutRateContractTable.value = result["result"];
      const FileUploadresult =
        await StockWOFileUploadServices.getStockWOFileById(StockTransTMId);
      if (FileUploadresult["result"].length > 0) {
        for (let i = 0; i < FileUploadresult["result"].length; i++) {
          let Fileobj = {};
          (Fileobj["url"] =
            FileUploadresult["result"][i].FileName.split("/FileUpload/")[1]),
            (Fileobj["fileName"] =
              FileUploadresult["result"][i].FileName.split("/").pop()),
            (Fileobj["fileType"] = Fileobj["url"].split("/")[0]),
            (Fileobj["fullPath"] = FileUploadresult["result"][i].FileName),
            (Fileobj["Id"] = FileUploadresult["result"][i].Id),
            uploadedTableList.value.push(Fileobj);
        }
      }
    }

    const dataItems = ref({});
    //Item Edit
    function IsItemEdit(data) {
      debugger;
      dataItems.value = {};
      dataItems.value = data;
      dataItems.value["IsEdit"] = 1;
      displayClass.value = "show";
      EditFlag = 1;
    }

    //Item Delete for with Rate Contract Table
    async function IsItemDelete(data) {
      debugger;
      let msg = null;
      if (data["StockDetailsId"]) {
        const result = await WithoutStockService.deleteStockWoDetails(
          data["StockDetailsId"]
        );
        msg = result["ErrorInfo"].ErrorCode;
      }
      if (msg == null) {
        items.value = items.value.filter(
          (item) => item["ItemId"] != data.ItemId
        );
        WithRateContractTable.value = WithRateContractTable.value.filter(
          (item) => item["ItemId"] != data.ItemId
        );

        toast.add({
          severity: "info",
          summary: "Item Removed",
          detail: "",
          life: 3000,
        });
        return;
      }
    }

    //Item Delete for Without Rate Contract table
    async function IsItemDelete1(data) {
      debugger;
      let msg = null;
      if (data["StockDetailsId"]) {
        const result = await WithoutStockService.deleteStockWoDetails(
          data["StockDetailsId"]
        );
        msg = result["ErrorInfo"].ErrorCode;
      }
      if (msg == null) {
        items.value = items.value.filter(
          (item) => item["ItemId"] != data.ItemId
        );

        WithoutRateContractTable.value = WithoutRateContractTable.value.filter(
          (item) => item["ItemId"] != data.ItemId
        );

        toast.add({
          severity: "info",
          summary: "Item Removed",
          detail: "",
          life: 3000,
        });
        return;
      }
    }

    function TotalGrossCalc(value1) {
      debugger;
      grossvalues.value.grossamount = value1.grossamount;
      grossvalues.value.totalqty = value1.totalqty;
      grossvalues.value.taxamount = value1.taxamount;
      grossvalues.value.totaldiscountamount = value1.totaldiscountamount;
      grossvalues.value.othercharges = value1.totalothercharges;
      grossvalues.value.transportcharges = value1.totaltransportcharges;
      grossvalues.value.servicecharges = value1.totalservicecharges;
      grossvalues.value.netamount = value1.netamount;
    }

    //PI and PO Creation
    let PIValue = 0;
    let PIValue1 = 0;
    //let insertValue = 1;
    let RefContent = "";
    var arr: any = [];
    // async function IsSubmit() {
    //   debugger;

    //   let result: any = "";
    //   let PIid = 0;
    //   let message;
    //   let requestlength = requestid.value.RequestIDValue.length;

    //   if (PIValue1 == 0) {
    //     if (WithRateContractTable.value.length == 0) {
    //       toast.add({
    //         severity: "warn",
    //         summary: "Add the Items",
    //         detail: "",
    //         life: 3000,
    //       });
    //       return;
    //     } else {
    //       let suppliers: any = [];
    //       for (let i = 0; i < WithRateContractTable.value.length; i++) {
    //         let supplier = WithRateContractTable.value[i].SupplierId;
    //         suppliers.push(WithRateContractTable.value[i]["supplierId"]);
    //       }

    //       const hasNullValue = Object.values(suppliers).some(
    //         (value) => value === null
    //       );

    //       if (hasNullValue) {
    //         toast.add({
    //           severity: "warn",
    //           summary: "Select the Suppliers for the Items",
    //           detail: "",
    //           life: 3000,
    //         });
    //         return;
    //       } else {
    //         ObjVal.value.CreatedAt = moment().format(
    //           "YYYY-MM-DDTHH:mm:ss.SSSZ"
    //         );
    //         ObjVal.value.ModifiedAt = moment().format(
    //           "YYYY-MM-DDTHH:mm:ss.SSSZ"
    //         );
    //         ObjVal.value.BranchId = queryBranchId;
    //         ObjVal.value.HospitalId = HospitalId;
    //         ObjVal.value.ModifiedBy = UserId;
    //         ObjVal.value.CreatedBy = UserId;
    //         ObjVal.value.EntityId = Number(Entitydata.value);
    //         ObjVal.value.EntityOperationId = OperationId;

    //         ObjVal.value.DocType = "2";
    //         ObjVal.value.RefNo = RequestId;
    //         ObjVal.value.StoreId = StoreID;
    //         ObjVal.value.Amount = grossvalues.value.grossamount;
    //         ObjVal.value.StoreBrMapId = Number(JSON.parse(String(routes.query.data)).StoreBrMapId ?? 0)

    //         if (StockWoTransTMId != "0") {
    //           ObjVal.value.Id = StockWoTransTMId;
    //           result = await WithoutStockService.updateStockWOTM(ObjVal.value);
    //         } else {
    //           result = await WithoutStockService.createStockWOTM(ObjVal.value);
    //         }

    //         message = result["ErrorInfo"].ErrorCode;

    //         if (result["result"] == false) {
    //           PIid = StockWoTransTMId;
    //         } else {
    //           PIid = result["result"];
    //         }

    //         if (message == null) {
    //           debugger;

    //           // let LineItems: any = items.value;
    //           let LineItems: any = WithRateContractTable.value;
    //           for (let i = 0; i < LineItems.length; i++) {
    //             if (LineItems[i]["ItemQuantity"] != 0) {
    //               let obj = {};
    //               (obj["Id"] = LineItems[i]["StockDetailsId"]),
    //                 (obj["ItemId"] = LineItems[i]["ItemId"]),
    //                 (obj["Qty"] = LineItems[i]["ItemQuantity"]),
    //                 (obj["RefId"] = PIid),
    //                 (obj["PackSizeId"] = LineItems[i]["PackSizeId"]),
    //                 (obj["HSNId"] = LineItems[i]["HSNId"]),
    //                 (obj["Rate"] = LineItems[i]["Rate"]),
    //                 (obj["UnitRate"] = LineItems[i]["UnitRate"]),
    //                 (obj["CreatedAt"] = moment().format(
    //                   "YYYY-MM-DDTHH:mm:ss.SSSZ"
    //                 )),
    //                 (obj["ModifiedAt"] = moment().format(
    //                   "YYYY-MM-DDTHH:mm:ss.SSSZ"
    //                 )),
    //                 (obj["CreatedBy"] = UserId),
    //                 (obj["ModifiedBy"] = UserId),
    //                 (arr[i] = obj);
    //             }
    //           }

    //           console.log(arr);
    //           let result = await WithoutStockService.createStockWODetails(arr);
    //           let msgMapping = result["ErrorInfo"].ErrorCode;
    //           if (msgMapping == null) {
    //             requestid.value.RequestIDValue = "";
    //             //  GetCode();
    //           }
    //         }
    //       }
    //     }
    //   }
    //   //PO Creaton begin
    //   if (StockWoTransTMId == "0") {
    //     let arraylength = WithRateContractTable.value.length;

    //     let QuantityValues: any = [];
    //     for (let i = 0; i < WithRateContractTable.value.length; i++) {
    //       let qty = WithRateContractTable.value[i].ItemQuantity;
    //       QuantityValues.push(WithRateContractTable.value[i]["ItemQuantity"]);
    //     }

    //     // Filtering out non-numeric values and converting them to numbers
    //     let numericValues: number[] = QuantityValues.filter(
    //       (value) => typeof value === "number" || !isNaN(Number(value))
    //     ).map((value) => Number(value));

    //     // Calculating the sum of the numeric values
    //     let SumValues: number = numericValues.reduce(
    //       (acc, value) => acc + value,
    //       0
    //     );

    //     console.log(SumValues);
    //     if (WithRateContractTable.value.length == 0) {
    //       toast.add({
    //         severity: "warn",
    //         summary: "Add the Items",
    //         detail: "",
    //         life: 3000,
    //       });
    //       return;
    //     } else if (SumValues > 0) {
    //       let supvalue = WithRateContractTable.value["supplierId"];

    //       let suppliers: any = [];
    //       for (let i = 0; i < WithRateContractTable.value.length; i++) {
    //         let supplier = WithRateContractTable.value[i].SupplierId;
    //         suppliers.push(WithRateContractTable.value[i]["supplierId"]);
    //       }

    //       const hasNullValue = Object.values(suppliers).some(
    //         (value) => value === null
    //       );

    //       if (hasNullValue) {
    //         toast.add({
    //           severity: "warn",
    //           summary: "Select the Suppliers for the Items",
    //           detail: "",
    //           life: 3000,
    //         });
    //         return;
    //       } else {
    //         let uniqueSuppliers = suppliers.filter((supplier, index) => {
    //           return suppliers.indexOf(supplier) === index;
    //         });

    //         console.log(uniqueSuppliers);

    //         let filteredSupplierIds: any = uniqueSuppliers;
    //         const filteredItems = WithRateContractTable.value.filter((item) => {
    //           return (
    //             item.hasOwnProperty("supplierId") &&
    //             filteredSupplierIds.includes(item.supplierId)
    //           );
    //         });

    //         console.log("filteredItems", filteredItems);
    //         const groupedItems = filteredItems.reduce(
    //           (accumulator, currentValue) => {
    //             const supplierId = currentValue.supplierId;
    //             if (!accumulator[supplierId]) {
    //               accumulator[supplierId] = [];
    //             }
    //             accumulator[supplierId].push(currentValue);
    //             return accumulator;
    //           },
    //           {}
    //         );

    //         console.log(groupedItems);

    //         for (const key in groupedItems) {
    //           const currentArray = groupedItems[key];

    //           ObjVal.value.DocType = "5";

    //           if (PIValue1 != 0) {
    //             ObjVal.value.RefId = PIValue1;
    //           } else {
    //             ObjVal.value.RefId = PIid;
    //           }

    //           ObjVal.value.StoreId = StoreID;
    //           ObjVal.value.Amount = grossvalues.value.grossamount;
    //           ObjVal.value.SupplierId = currentArray[0]["supplierId"];
    //           ObjVal.value.CreatedAt = moment().format(
    //             "YYYY-MM-DDTHH:mm:ss.SSSZ"
    //           );
    //           ObjVal.value.ModifiedAt = moment().format(
    //             "YYYY-MM-DDTHH:mm:ss.SSSZ"
    //           );
    //           ObjVal.value.BranchId = queryBranchId;
    //           ObjVal.value.HospitalId = HospitalId;
    //           ObjVal.value.ModifiedBy = UserId;
    //           ObjVal.value.CreatedBy = UserId;
    //           ObjVal.value.EntityId = 145;
    //           ObjVal.value.EntityOperationId = 644;
    //           ObjVal.value.StoreBrMapId = Number(JSON.parse(String(routes.query.data)).StoreBrMapId ?? 0)

    //           if (StockWoTransTMId != "0") {
    //             result = await WithoutStockService.updateStockWOTM(
    //               ObjVal.value
    //             );
    //           } else {
    //             result = await WithoutStockService.createStockWOTM(
    //               ObjVal.value
    //             );
    //           }

    //           message = result["ErrorInfo"].ErrorCode;

    //           let id = 0;

    //           if (result["result"] == false) {
    //             id = StockWoTransTMId;
    //           } else {
    //             id = result["result"];
    //           }

    //           var POarr: any = [];
    //           if (message == null) {
    //             debugger;
    //             for (let i = 0; i < currentArray.length; i++) {
    //               if (currentArray[i]["ItemQuantity"] != 0) {
    //                 let obj = {};
    //                 (obj["Id"] = currentArray[i]["StockDetailsId"]),
    //                   (obj["ItemId"] = currentArray[i]["ItemId"]),
    //                   (obj["Qty"] = currentArray[i]["ItemQuantity"]),
    //                   (obj["RefId"] = id),
    //                   (obj["PackSizeId"] = currentArray[i]["PackSizeId"]),
    //                   (obj["HSNId"] = currentArray[i]["HSNId"]),
    //                   (obj["Rate"] = currentArray[i]["Rate"]),
    //                   (obj["UnitRate"] = currentArray[i]["UnitRate"]),
    //                   (obj["CreatedAt"] = moment().format(
    //                     "YYYY-MM-DDTHH:mm:ss.SSSZ"
    //                   )),
    //                   (obj["ModifiedAt"] = moment().format(
    //                     "YYYY-MM-DDTHH:mm:ss.SSSZ"
    //                   )),
    //                   (obj["CreatedBy"] = UserId),
    //                   (obj["ModifiedBy"] = UserId),
    //                   (POarr[i] = obj);
    //               }
    //             }

    //             let result = await WithoutStockService.createStockWODetails(
    //               POarr
    //             );

    //             message = result["ErrorInfo"].ErrorCode;
    //           }
    //           console.log();
    //         }
    //       }
    //     } else {
    //       toast.add({
    //         severity: "info",
    //         summary: "Add the quantity for the Items",
    //         detail: "",
    //         life: 3000,
    //       });
    //       return;
    //     }
    //   }
    //   //end
    //   if (StockWoTransTMId != 0) {
    //     updatepop.value = true;
    //   } else {
    //     PrintCrystalReport(PIid);
    //     successpop.value = true;
    //     PIValue = PIid;
    //     RefContent = "IsQuoteCreate";
    //     //insertValue = insertValue + 1;

    //     Object.values(WithRateContractTable.value).forEach((item1: any) => {
    //       Object.values(WithoutRateContractTable.value).forEach(
    //         (items: any) => {
    //           if (item1.ItemId == items.ItemId) {
    //             items.ItemQuantity = 0;
    //             // items.ItemQuantity =
    //             //   Number(items.ItemQuantity) + Number(item1.ItemQuantity);
    //           }
    //         }
    //       );
    //     });

    //     WithRateContractTable.value = "";
    //   }
    // }

    async function IsSubmit() {
      debugger;

      let result: any = "";
      let PIid = 0;
      let message;
      var FileUploadArray: any = [];
      let requestlength = requestid.value.RequestIDValue.length;

      if (PIValue1 == 0) {
        if (WithRateContractTable.value.length == 0) {
          toast.add({
            severity: "warn",
            summary: "Add the Items",
            detail: "",
            life: 3000,
          });
          return;
        } else {
          let suppliers: any = [];
          for (let i = 0; i < WithRateContractTable.value.length; i++) {
            let supplier = WithRateContractTable.value[i].SupplierId;
            suppliers.push(WithRateContractTable.value[i]["supplierId"]);
          }

          const hasNullValue = Object.values(suppliers).some(
            (value) => value === null
          );

          if (hasNullValue) {
            toast.add({
              severity: "warn",
              summary: "Select the Suppliers for the Items",
              detail: "",
              life: 3000,
            });
            return;
          } else {
            ObjVal.value.CreatedAt = moment().format(
              "YYYY-MM-DDTHH:mm:ss.SSSZ"
            );
            ObjVal.value.ModifiedAt = moment().format(
              "YYYY-MM-DDTHH:mm:ss.SSSZ"
            );
            ObjVal.value.BranchId = queryBranchId;
            ObjVal.value.HospitalId = HospitalId;
            ObjVal.value.ModifiedBy = UserId;
            ObjVal.value.CreatedBy = UserId;
            ObjVal.value.EntityId = Number(Entitydata.value);
            ObjVal.value.EntityOperationId = OperationId;

            ObjVal.value.DocType = "2";
            ObjVal.value.RefNo = RequestId;
            ObjVal.value.StoreId = StoreID;
            ObjVal.value.Amount = grossvalues.value.grossamount;
            ObjVal.value.StoreBrMapId = Number(
              JSON.parse(String(routes.query.data)).StoreBrMapId ?? 0
            );

            if (EditFlag == 1) {
              ObjVal.value.IsDraft = 1;
            } else {
              ObjVal.value.IsDraft = 0;
            }
            if (StockWoTransTMId != 0) {
              ObjVal.value.Id = StockWoTransTMId;
            }
            let LineItems: any = WithRateContractTable.value;
            for (let i = 0; i < LineItems.length; i++) {
              if (LineItems[i]["ItemQuantity"] != 0) {
                let obj = {};
                (obj["Id"] = LineItems[i]["StockDetailsId"]),
                  (obj["ItemId"] = LineItems[i]["ItemId"]),
                  (obj["Qty"] = LineItems[i]["ItemQuantity"]),
                  (obj["RefId"] = ObjVal.value.Id),
                  (obj["PackSizeId"] = LineItems[i]["PackSizeId"]),
                  (obj["HSNId"] = LineItems[i]["HSNId"]),
                  (obj["Rate"] = LineItems[i]["Rate"]),
                  (obj["UnitRate"] = LineItems[i]["UnitRate"]),
                  (obj["CreatedAt"] = moment().format(
                    "YYYY-MM-DDTHH:mm:ss.SSSZ"
                  )),
                  (obj["ModifiedAt"] = moment().format(
                    "YYYY-MM-DDTHH:mm:ss.SSSZ"
                  )),
                  (obj["CreatedBy"] = UserId),
                  (obj["ModifiedBy"] = UserId),
                  (arr[i] = obj);
              }
            }

            ObjVal.value.StockWODetailList = arr;

            let result = await WithoutStockService.createStockWODraft(
              ObjVal.value
            );
            PIid = result["result"][0].Id;
            ObjVal.value.Id = PIid;
            for (let i = 0; i < ObjVal.value.StockWODetailList.length; i++) {
              const ResultList = result["result"][0];
              items.value[items.value.length - 1].Id =
                ResultList.StockWODetailList[0]["Id"];
              items.value[items.value.length - 1].StockDetailsId =
                ResultList.StockWODetailList[0]["Id"];
            }
            if (uploadedTableList.value.length != 0) {
              for (let i = 0; i < uploadedTableList.value.length; i++) {
                let Fileobj = {};
                (Fileobj["Id"] = uploadedTableList.value[i].Id),
                  (Fileobj["DocType"] = "2"),
                  (Fileobj["RefId"] = ObjVal.value.Id),
                  (Fileobj["FileName"] = uploadedTableList.value[i].fileName),
                  (Fileobj["CreatedAt"] = moment().format(
                    "YYYY-MM-DDTHH:mm:ss.SSSZ"
                  )),
                  (Fileobj["CreatedBy"] = UserId),
                  (Fileobj["ModifiedBy"] = 0),
                  (Fileobj["EntityId"] = Number(Entitydata.value)),
                  (Fileobj["IsApproved"] = 0),
                  FileUploadArray.push(Fileobj);
              }
              StockWOFileUpload.value = FileUploadArray;
              let FileUploadResult =
                await StockWOFileUploadServices.insertStockWOFile(
                  StockWOFileUpload.value
                );
            }
            if (DeletedFileUpload.length > 0) {
              debugger;
              let result = await StockWOFileUploadServices.DeleteList(
                DeletedFileUpload.join(",")
              );
            }
          }
        }
      }
      //PO Creaton begin
      if (StockWoTransTMId == "0") {
        let arraylength = WithRateContractTable.value.length;

        let QuantityValues: any = [];
        for (let i = 0; i < WithRateContractTable.value.length; i++) {
          let qty = WithRateContractTable.value[i].ItemQuantity;
          QuantityValues.push(WithRateContractTable.value[i]["ItemQuantity"]);
        }

        // Filtering out non-numeric values and converting them to numbers
        let numericValues: number[] = QuantityValues.filter(
          (value) => typeof value === "number" || !isNaN(Number(value))
        ).map((value) => Number(value));

        // Calculating the sum of the numeric values
        let SumValues: number = numericValues.reduce(
          (acc, value) => acc + value,
          0
        );

        console.log(SumValues);
        if (WithRateContractTable.value.length == 0) {
          toast.add({
            severity: "warn",
            summary: "Add the Items",
            detail: "",
            life: 3000,
          });
          return;
        } else if (SumValues > 0) {
          let supvalue = WithRateContractTable.value["supplierId"];

          let suppliers: any = [];
          for (let i = 0; i < WithRateContractTable.value.length; i++) {
            let supplier = WithRateContractTable.value[i].SupplierId;
            suppliers.push(WithRateContractTable.value[i]["supplierId"]);
          }

          const hasNullValue = Object.values(suppliers).some(
            (value) => value === null
          );

          if (hasNullValue) {
            toast.add({
              severity: "warn",
              summary: "Select the Suppliers for the Items",
              detail: "",
              life: 3000,
            });
            return;
          } else {
            let uniqueSuppliers = suppliers.filter((supplier, index) => {
              return suppliers.indexOf(supplier) === index;
            });

            console.log(uniqueSuppliers);

            let filteredSupplierIds: any = uniqueSuppliers;
            const filteredItems = WithRateContractTable.value.filter((item) => {
              return (
                item.hasOwnProperty("supplierId") &&
                filteredSupplierIds.includes(item.supplierId)
              );
            });

            console.log("filteredItems", filteredItems);
            const groupedItems = filteredItems.reduce(
              (accumulator, currentValue) => {
                const supplierId = currentValue.supplierId;
                if (!accumulator[supplierId]) {
                  accumulator[supplierId] = [];
                }
                accumulator[supplierId].push(currentValue);
                return accumulator;
              },
              {}
            );

            console.log(groupedItems);

            for (const key in groupedItems) {
              const currentArray = groupedItems[key];

              ObjVal.value.DocType = "5";

              if (PIValue1 != 0) {
                ObjVal.value.RefId = PIValue1;
              } else {
                ObjVal.value.RefId = PIid;
              }

              ObjVal.value.StoreId = StoreID;
              ObjVal.value.Amount = grossvalues.value.grossamount;
              ObjVal.value.SupplierId = currentArray[0]["supplierId"];
              ObjVal.value.CreatedAt = moment().format(
                "YYYY-MM-DDTHH:mm:ss.SSSZ"
              );
              ObjVal.value.ModifiedAt = moment().format(
                "YYYY-MM-DDTHH:mm:ss.SSSZ"
              );
              ObjVal.value.BranchId = queryBranchId;
              ObjVal.value.HospitalId = HospitalId;
              ObjVal.value.ModifiedBy = UserId;
              ObjVal.value.CreatedBy = UserId;
              ObjVal.value.EntityId = 3044;
              ObjVal.value.EntityOperationId = 3044001;
              ObjVal.value.StoreBrMapId = Number(
                JSON.parse(String(routes.query.data)).StoreBrMapId ?? 0
              );
              if (EditFlag == 1) {
                ObjVal.value.IsDraft = 1;
              } else {
                ObjVal.value.IsDraft = 0;
              }
              // if (StockWoTransTMId != "0") {
              //   result = await WithoutStockService.updateStockWOTM(
              //     ObjVal.value
              //   );
              // } else {
              //   result = await WithoutStockService.createStockWOTM(
              //     ObjVal.value
              //   );
              // }

              // message = result["ErrorInfo"].ErrorCode;

              let id = 0;

              if (StockWoTransTMId != 0) {
                ObjVal.value.Id = StockWoTransTMId;
              }

              var POarr: any = [];
              // if (message == null) {
              //   debugger;
              for (let i = 0; i < currentArray.length; i++) {
                if (currentArray[i]["ItemQuantity"] != 0) {
                  let obj = {};
                  (obj["Id"] = currentArray[i]["StockDetailsId"]),
                    (obj["ItemId"] = currentArray[i]["ItemId"]),
                    (obj["Qty"] = currentArray[i]["ItemQuantity"]),
                    (obj["RefId"] = ObjVal.value.Id),
                    (obj["PackSizeId"] = currentArray[i]["PackSizeId"]),
                    (obj["HSNId"] = currentArray[i]["HSNId"]),
                    (obj["Rate"] = currentArray[i]["Rate"]),
                    (obj["UnitRate"] = currentArray[i]["UnitRate"]),
                    (obj["CreatedAt"] = moment().format(
                      "YYYY-MM-DDTHH:mm:ss.SSSZ"
                    )),
                    (obj["ModifiedAt"] = moment().format(
                      "YYYY-MM-DDTHH:mm:ss.SSSZ"
                    )),
                    (obj["CreatedBy"] = UserId),
                    (obj["ModifiedBy"] = UserId),
                    (POarr[i] = obj);
                }
              }

              ObjVal.value.StockWODetailList = POarr;

              let result = await WithoutStockService.createStockWODraft(
                ObjVal.value
              );
              PIid = result["result"][0].Id;
              ObjVal.value.Id = PIid;
              for (let i = 0; i < ObjVal.value.StockWODetailList.length; i++) {
                const ResultList = result["result"][0];
                items.value[items.value.length - 1].Id =
                  ResultList.StockWODetailList[0]["Id"];
                items.value[items.value.length - 1].StockDetailsId =
                  ResultList.StockWODetailList[0]["Id"];
              }

              message = result["ErrorInfo"].ErrorCode;
            }
            console.log();
            // }
          }
        } else {
          toast.add({
            severity: "info",
            summary: "Add the quantity for the Items",
            detail: "",
            life: 3000,
          });
          return;
        }
      }
      //end
      if (EditFlag == 1 && StockWoTransTMId != 0) {
        updatepop.value = true;
      } else {
        PrintCrystalReport(PIid);
        successpop.value = true;
        PIValue = PIid;
        RefContent = "IsQuoteCreate";
        //insertValue = insertValue + 1;

        Object.values(WithRateContractTable.value).forEach((item1: any) => {
          Object.values(WithoutRateContractTable.value).forEach(
            (items: any) => {
              if (item1.ItemId == items.ItemId) {
                items.ItemQuantity = 0;
                // items.ItemQuantity =
                //   Number(items.ItemQuantity) + Number(item1.ItemQuantity);
              }
            }
          );
        });

        WithRateContractTable.value = "";
      }
      EditFlag == 0;
    }

    const IsSubmitDraft = handleSubmit(async (values) => {
      debugger;

      let result: any = "";
      let PIid = 0;
      let message;
      let requestlength = requestid.value.RequestIDValue.length;
      var FileUploadArray: any = [];

      if (dupitems.value.length == 0) {
        toast.add({
          severity: "warn",
          summary: "Add the Items",
          detail: "",
          life: 3000,
        });
        return;
      } else {
        let suppliers: any = [];
        ObjVal.value.DocType = "2";
        ObjVal.value.RefNo = RequestId;
        ObjVal.value.StoreId = StoreID;
        ObjVal.value.Amount = grossvalues.value.grossamount;
        ObjVal.value.CreatedAt = moment().format("YYYY-MM-DDTHH:mm:ss.SSSZ");
        ObjVal.value.ModifiedAt = moment().format("YYYY-MM-DDTHH:mm:ss.SSSZ");
        ObjVal.value.BranchId = queryBranchId;
        ObjVal.value.HospitalId = HospitalId;
        ObjVal.value.ModifiedBy = UserId;
        ObjVal.value.CreatedBy = UserId;
        ObjVal.value.EntityId = Number(Entitydata.value);
        ObjVal.value.EntityOperationId = OperationId;
        ObjVal.value.StoreBrMapId = Number(
          JSON.parse(String(routes.query.data)).StoreBrMapId ?? 0
        );
        ObjVal.value.IsDraft = 1;
        if (StockWoTransTMId != 0) {
          ObjVal.value.Id = StockWoTransTMId;
        }
        let dupitemsDraft: any = dupitems.value;
        for (let i = 0; i < dupitemsDraft.length; i++) {
          if (dupitemsDraft[i]["ItemQuantity"] != 0) {
            let obj = {};
            (obj["Id"] = dupitemsDraft[i]["StockDetailsId"]),
              (obj["ItemId"] = dupitemsDraft[i]["ItemId"]),
              (obj["Qty"] = dupitemsDraft[i]["ItemQuantity"]),
              (obj["RefId"] = PIid),
              (obj["PackSizeId"] = dupitemsDraft[i]["PackSizeId"]),
              (obj["HSNId"] = dupitemsDraft[i]["HSNId"]),
              (obj["CreatedAt"] = moment().format("YYYY-MM-DDTHH:mm:ss.SSSZ")),
              (obj["ModifiedAt"] = moment().format("YYYY-MM-DDTHH:mm:ss.SSSZ")),
              (obj["CreatedBy"] = UserId),
              (obj["ModifiedBy"] = UserId),
              (obj["Rate"] = dupitemsDraft[i]["Rate"]),
              (obj["UnitRate"] = dupitemsDraft[i]["UnitRate"]),
              (arr[i] = obj);
          }
        }
        ObjVal.value.StockWODetailList = arr;

        let result = await WithoutStockService.createStockWODraft(ObjVal.value);
        PIid = result["result"][0].Id;
        ObjVal.value.Id = PIid;
        for (let i = 0; i < ObjVal.value.StockWODetailList.length; i++) {
          const ResultList = result["result"][0];
          WithoutRateContractTable.value[
            WithoutRateContractTable.value.length - 1
          ].Id = ResultList.StockWODetailList[0]["Id"];
          WithoutRateContractTable.value[
            WithoutRateContractTable.value.length - 1
          ].StockDetailsId = ResultList.StockWODetailList[0]["Id"];
        }
        if (uploadedTableList.value.length != 0) {
          for (let i = 0; i < uploadedTableList.value.length; i++) {
            let Fileobj = {};
            (Fileobj["Id"] = uploadedTableList.value[i].Id),
              (Fileobj["DocType"] = "2"),
              (Fileobj["RefId"] = ObjVal.value.Id),
              (Fileobj["FileName"] = uploadedTableList.value[i].fileName),
              (Fileobj["CreatedAt"] = moment().format(
                "YYYY-MM-DDTHH:mm:ss.SSSZ"
              )),
              (Fileobj["CreatedBy"] = UserId),
              (Fileobj["ModifiedBy"] = 0),
              (Fileobj["EntityId"] = Number(Entitydata.value)),
              (Fileobj["IsApproved"] = 0),
              FileUploadArray.push(Fileobj);
          }
          StockWOFileUpload.value = FileUploadArray;
          let FileUploadResult =
            await StockWOFileUploadServices.insertStockWOFile(
              StockWOFileUpload.value
            );
          debugger;
          for (let i = 0; i < uploadedTableList.value.length; i++) {
            uploadedTableList.value[i].Id = FileUploadResult["result"][i]["Id"];
          }
        }
        let msgMapping = result["ErrorInfo"].ErrorCode;
        if (msgMapping == null) {
          requestid.value.RequestIDValue = "";
        }
      }
    });

    // //PI and Quote Creation

    //PI and Quote Creation
    async function IsSubmitQuote() {
      debugger;
      let result: any = "";
      let PIid = 0;
      let message;
      let requestlength = requestid.value.RequestIDValue.length;
      if (PIValue == 0) {
        if (WithoutRateContractTable.value.length == 0) {
          toast.add({
            severity: "warn",
            summary: "Add the Items",
            detail: "",
            life: 3000,
          });
          return;
        } else {
          let suppliers: any = [];
          for (let i = 0; i < WithoutRateContractTable.value.length; i++) {
            let supplier = WithoutRateContractTable.value[i].supplierIdwo;
            suppliers.push(WithoutRateContractTable.value[i]["supplierIdwo"]);
          }

          const hasNullValue = Object.values(suppliers).some(
            (value) => value === null
          );

          if (hasNullValue) {
            toast.add({
              severity: "warn",
              summary: "Select the Suppliers for the Items",
              detail: "",
              life: 3000,
            });
            return;
          } else {
            ObjVal.value.DocType = "2";
            ObjVal.value.RefNo = RequestId;
            ObjVal.value.StoreId = StoreID;
            ObjVal.value.Amount = grossvalues.value.grossamount;
            ObjVal.value.CreatedAt = moment().format(
              "YYYY-MM-DDTHH:mm:ss.SSSZ"
            );
            ObjVal.value.ModifiedAt = moment().format(
              "YYYY-MM-DDTHH:mm:ss.SSSZ"
            );
            ObjVal.value.BranchId = queryBranchId;
            ObjVal.value.HospitalId = HospitalId;
            ObjVal.value.ModifiedBy = UserId;
            ObjVal.value.CreatedBy = UserId;
            ObjVal.value.EntityId = Number(Entitydata.value);
            ObjVal.value.EntityOperationId = OperationId;
            ObjVal.value.StoreBrMapId = Number(
              JSON.parse(String(routes.query.data)).StoreBrMapId ?? 0
            );
            if (EditFlag == 1) {
              ObjVal.value.IsDraft = 1;
            } else {
              ObjVal.value.IsDraft = 0;
            }
            // if (StockWoTransTMId != "0") {
            //   ObjVal.value.Id = StockWoTransTMId;
            //   result = await WithoutStockService.updateStockWOTM(ObjVal.value);
            // } else {
            //   result = await WithoutStockService.createStockWOTM(ObjVal.value);
            // }

            // message = result["ErrorInfo"].ErrorCode;

            if (StockWoTransTMId != 0) {
              ObjVal.value.Id = StockWoTransTMId;
            }

            // if (message == null) {
            //   debugger;

            let LineItems: any = WithoutRateContractTable.value;
            for (let i = 0; i < LineItems.length; i++) {
              if (LineItems[i]["ItemQuantity"] != 0) {
                let obj = {};
                (obj["Id"] = LineItems[i]["StockDetailsId"]),
                  (obj["ItemId"] = LineItems[i]["ItemId"]),
                  (obj["Qty"] = LineItems[i]["ItemQuantity"]),
                  (obj["RefId"] = ObjVal.value.Id),
                  (obj["PackSizeId"] = LineItems[i]["PackSizeId"]),
                  (obj["HSNId"] = LineItems[i]["HSNId"]),
                  (obj["CreatedAt"] = moment().format(
                    "YYYY-MM-DDTHH:mm:ss.SSSZ"
                  )),
                  (obj["ModifiedAt"] = moment().format(
                    "YYYY-MM-DDTHH:mm:ss.SSSZ"
                  )),
                  (obj["CreatedBy"] = UserId),
                  (obj["ModifiedBy"] = UserId),
                  (obj["Rate"] = LineItems[i]["Rate"]),
                  (obj["UnitRate"] = LineItems[i]["UnitRate"]),
                  (arr[i] = obj);
              }
            }

            ObjVal.value.StockWODetailList = arr;

            let result = await WithoutStockService.createStockWODraft(
              ObjVal.value
            );
            PIid = result["result"][0].Id;
            ObjVal.value.Id = PIid;
            for (let i = 0; i < ObjVal.value.StockWODetailList.length; i++) {
              const ResultList = result["result"][0];
              items.value[items.value.length - 1].Id =
                ResultList.StockWODetailList[0]["Id"];
              items.value[items.value.length - 1].StockDetailsId =
                ResultList.StockWODetailList[0]["Id"];
            }
            //}
          }
        }
      }

      //Quote Creaton begin
      if (StockWoTransTMId == "0") {
        let arraylength = WithoutRateContractTable.value.length;

        let QuantityValues: any = [];
        for (let i = 0; i < WithoutRateContractTable.value.length; i++) {
          let qty = WithoutRateContractTable.value[i].ItemQuantity;
          QuantityValues.push(
            WithoutRateContractTable.value[i]["ItemQuantity"]
          );
        }

        // Filtering out non-numeric values and converting them to numbers
        let numericValues: number[] = QuantityValues.filter(
          (value) => typeof value === "number" || !isNaN(Number(value))
        ).map((value) => Number(value));

        // Calculating the sum of the numeric values
        let SumValues: number = numericValues.reduce(
          (acc, value) => acc + value,
          0
        );

        console.log(SumValues);
        if (WithoutRateContractTable.value.length == 0) {
          toast.add({
            severity: "warn",
            summary: "Add the Items",
            detail: "",
            life: 3000,
          });
          return;
        } else if (SumValues > 0) {
          // let suppliers: any = [];
          // for (let i = 0; i < WithoutRateContractTable.value.length; i++) {
          //   let supplier = WithoutRateContractTable.value[i].supplierIdwo;
          //   suppliers.push(WithoutRateContractTable.value[i]["supplierIdwo"]);
          // }

          let suppliers: any = [];
          for (let i = 0; i < WithoutRateContractTable.value.length; i++) {
            let supplier = WithoutRateContractTable.value[i].supplierIdwo;
            let itemQuantity = WithoutRateContractTable.value[i].ItemQuantity;
            if (itemQuantity !== 0) {
              suppliers.push(supplier);
            }
          }

          const hasNullValue = Object.values(suppliers).some(
            (value) => value === null
          );

          if (hasNullValue) {
            toast.add({
              severity: "warn",
              summary: "Select the Suppliers for the Items",
              detail: "",
              life: 3000,
            });
            return;
          } else {
            suppliers = suppliers.flat();

            let uniqueSuppliers = suppliers.filter((supplier, index) => {
              return suppliers.indexOf(supplier) === index;
            });

            console.log(uniqueSuppliers);

            let filteredSupplierIds: any = uniqueSuppliers;

            const groupedItems = filteredSupplierIds.map((value) => {
              const group: any = [];
              let arr = JSON.parse(
                JSON.stringify(WithoutRateContractTable.value)
              );

              // .filter((item)=>item["supplierIdwo"]!=null)

              arr
                .filter((item) => item["supplierIdwo"] != null)
                .forEach((item: any) => {
                  if (item.supplierIdwo.includes(value)) {
                    let obj: any = {};
                    obj = item;
                    obj.supply = value;
                    group.push(obj);
                  }
                });
              return group;
            });

            console.log("filteredItems", groupedItems);

            // console.log(groupedItems);

            for (const key in groupedItems) {
              const currentArray = groupedItems[key];
              console.log(currentArray);

              ObjVal.value.DocType = "3";

              if (PIValue != 0) {
                ObjVal.value.RefId = PIValue;
              } else {
                ObjVal.value.RefId = PIid;
              }

              ObjVal.value.StoreId = StoreID;
              ObjVal.value.Amount = grossvalues.value.grossamount;
              ObjVal.value.SupplierId = currentArray[0]["supply"];
              ObjVal.value.CreatedAt = moment().format(
                "YYYY-MM-DDTHH:mm:ss.SSSZ"
              );
              ObjVal.value.ModifiedAt = moment().format(
                "YYYY-MM-DDTHH:mm:ss.SSSZ"
              );
              ObjVal.value.BranchId = queryBranchId;
              ObjVal.value.HospitalId = HospitalId;
              ObjVal.value.ModifiedBy = UserId;
              ObjVal.value.CreatedBy = UserId;
              ObjVal.value.EntityId = 3037;
              ObjVal.value.EntityOperationId = 3037001;
              ObjVal.value.StoreBrMapId = Number(
                JSON.parse(String(routes.query.data)).StoreBrMapId ?? 0
              );
              if (EditFlag == 1) {
                ObjVal.value.IsDraft = 1;
              } else {
                ObjVal.value.IsDraft = 0;
              }
              // if (StockWoTransTMId != "0") {
              //   result = await WithoutStockService.updateStockWOTM(
              //     ObjVal.value
              //   );
              // } else {
              //   result = await WithoutStockService.createStockWOTM(
              //     ObjVal.value
              //   );
              // }

              // message = result["ErrorInfo"].ErrorCode;

              let id = 0;

              if (StockWoTransTMId != 0) {
                ObjVal.value.Id = StockWoTransTMId;
              }
              var POarr: any = [];
              // if (message == null) {
              //   debugger;
              for (let i = 0; i < currentArray.length; i++) {
                if (currentArray[i]["ItemQuantity"] != 0) {
                  let obj = {};
                  // (obj["Id"] = currentArray[i]["StockDetailsId"]),
                  (obj["Id"] = 0),
                    (obj["ItemId"] = currentArray[i]["ItemId"]),
                    (obj["Qty"] = currentArray[i]["ItemQuantity"]),
                    (obj["RefId"] = ObjVal.value.Id),
                    (obj["PackSizeId"] = currentArray[i]["PackSizeId"]),
                    (obj["HSNId"] = currentArray[i]["HSNId"]),
                    (obj["CreatedAt"] = moment().format(
                      "YYYY-MM-DDTHH:mm:ss.SSSZ"
                    )),
                    (obj["ModifiedAt"] = moment().format(
                      "YYYY-MM-DDTHH:mm:ss.SSSZ"
                    )),
                    (obj["CreatedBy"] = UserId),
                    (obj["ModifiedBy"] = UserId),
                    (obj["Rate"] = currentArray[i]["Rate"]),
                    (obj["UnitRate"] = currentArray[i]["UnitRate"]),
                    (POarr[i] = obj);
                }
              }

              ObjVal.value.StockWODetailList = POarr;

              let result = await WithoutStockService.createStockWODraft(
                ObjVal.value
              );
              PIid = result["result"][0].Id;
              ObjVal.value.Id = PIid;
              for (let i = 0; i < ObjVal.value.StockWODetailList.length; i++) {
                const ResultList = result["result"][0];
                items.value[items.value.length - 1].Id =
                  ResultList.StockWODetailList[0]["Id"];
                items.value[items.value.length - 1].StockDetailsId =
                  ResultList.StockWODetailList[0]["Id"];
              }
              message = result["ErrorInfo"].ErrorCode;
              // }
              console.log();
            }
          }
        } else {
          toast.add({
            severity: "info",
            summary: "Add the quantity for the Items",
            detail: "",
            life: 3000,
          });
          return;
        }
      }
      //end
      if (EditFlag != 1) {
        if (StockWoTransTMId != 0) {
          updatepop.value = true;
        } else {
          successpop.value = true;
          PIValue1 = PIid;
          RefContent = "IsPICreate";
          //insertValue = insertValue + 1;

          Object.values(WithRateContractTable.value).forEach((item1: any) => {
            Object.values(WithoutRateContractTable.value).forEach(
              (items: any) => {
                if (item1.ItemId == items.ItemId) {
                  item1.ItemQuantity = 0;
                  // item1.ItemQuantity =
                  //   Number(item1.ItemQuantity) - Number(items.ItemQuantity);
                }
              }
            );
          });

          WithoutRateContractTable.value = "";
        }
      } else {
      }
    }
    //ReOrder Level Table
    async function LoadReOrderLevel() {
      debugger;
      let result = await WithoutStockService.GetReOrderLevelList(StoreID, HospitalId, BranchId);
      console.log(result);
      result = result["result"];

      ReOrderData.value = result;
    }

    //Delete ReOrder level Items
    async function IsReOrderDelete(data) {
      debugger;
      let msg = null;

      if (msg == null) {
        ReOrderData.value = ReOrderData.value.filter(
          (item) => item["ItemId"] !== data.ItemId
        );
      }
      console.log(ReOrderData.value);
    }

    let msgcontent = ref({ contentvalue: "" });
    let warningmsgcontent = ref({ warningcontent: "" });
    const confirmval = ref();
    function AddSingleConfirmation(val) {
      debugger;
      confirmval.value = val;
      if (ReOrderData.value == "") {
        warningmsgcontent.value.warningcontent = t(
          "confirmation.thereisnoitems"
        );
        wariningPopup.value = true;
      } else if (selectedProduct.value == "" || selectedProduct.value == null) {
        warningmsgcontent.value.warningcontent = t(
          "confirmation.pleaseselecttheitems"
        );
        wariningPopup.value = true;
      } else {
        msgcontent.value.contentvalue = t(
          "confirmation.doyouwantaddselecteditemstorequest"
        );
        AddItemmodel.value = true;
      }
    }

    function AddAllConfirmation(val) {
      debugger;
      confirmval.value = val;
      if (ReOrderData.value == "") {
        warningmsgcontent.value.warningcontent = t(
          "confirmation.thereisnoitems"
        );
        wariningPopup.value = true;
      } else {
        msgcontent.value.contentvalue = t(
          "confirmation.doyouwantaddselecteditemstorequest"
        );
        AddItemmodel.value = true;
      }
    }

    function ClosewariningPopup() {
      debugger;
      wariningPopup.value = false;
    }

    function CopyReorderData(selectValue) {
      debugger;

      let dataArray: any = [];
      dataArray = JSON.parse(JSON.stringify(items.value));
      let selectedArray: any = [];
      let checkArray =
        selectValue == "All" ? ReOrderData.value : selectedProduct.value;
      selectedArray = JSON.parse(JSON.stringify(checkArray));
      dataArray.map((item: any) => {
        const item2 = selectedArray.find(
          (data: any) => data.ItemId == item.ItemId
        );
        if (item2) {
          item.ItemQuantity =
            parseInt(item.ItemQuantity) + parseInt(item2.ItemQuantity);
        }
      });

      console.log(items.value);

      let arr1: any = [];

      arr1 = selectedArray.filter(
        (value) => !dataArray.some((i1) => i1.ItemId == value.ItemId)
      );

      for (let i = 0; i < arr1.length; i++) {
        dataArray.push(arr1[i]);
      }

      WithRateContractTable.value = dataArray.filter(
        (item) => Number(item.RateContractCount) > 0
      );

      WithoutRateContractTable.value = dataArray;

      items.value = dataArray;
      dataItems.value = items.value;
      selectedProduct.value = null;

      AddItemmodel.value = false;
      clases.value.ItemsReOrderTab = 0;
    }

    function closetrigger() {
      successpop.value = false;
      updatepop.value = false;

      if (RefContent == "IsQuoteCreate") {
        if (WithoutRateContractTable.value.length > 0) {
          IsQuoteModel.value = true;
        } else {
          IsQuoteClose();
        }
      } else if (RefContent == "IsPICreate") {
        if (WithRateContractTable.value.length > 0) {
          IsPIModel.value = true;
        } else {
          IsPIClose();
        }
      } else {
        console.log(RefContent);
      }
    }

    const IsQuoteModel = ref(false);
    const IsPIModel = ref(false);

    function IsQuote() {
      debugger;
      IsQuoteModel.value = false;
      clases.value.WithAndWithoutRateTab = 1;
    }

    function IsQuoteClose() {
      debugger;
      IsQuoteModel.value = false;
      setupHistoryManagement(router, 2);
    }

    function IsPI() {
      debugger;
      IsPIModel.value = false;
      clases.value.WithAndWithoutRateTab = 0;
    }

    function IsPIClose() {
      debugger;
      IsPIModel.value = false;
      router.push({
        path: "/StoreTabDetails",
        query: {
          status: QueryStringValue3["status"],
          Id: StoreID,
          Type: "StoreId",
        },
      });
    }

    const onDropdownBlur = () => {
      console.log("js");
    };

    const ParameterValues = ref({ Id: 0 });
    const PrintType = ref({ Type: "S", FormId: 11, ModuleId: 3 });

    function PrintCrystalReport(Id) {
      debugger;
      CrystalReportPopup.value = true;
      ParameterValues.value.Id = Id;
    }

    const handleChangedocument = async (event: Event) => {
      debugger;
      debugger;
      let result;
      let files: any = "";
      const input = event.target as HTMLInputElement;
      files = input["files"];
      console.log(files);
      if (files && files.length > 0) {
        debugger;
        for (let i = 0; i < files.length; i++) {
          let form = new FormData();
          console.log(files[i]);
          form.append("file", files[i]);
          console.log(form);
          result = await common.uploadquotation(form, "TransactionFiles");
          console.log("Uploaded :", result);
          let ResponseValue = result;
          ResponseValue["Id"] = 0;
          fullPath.value = result.uploadPath;
          uploadedTableList.value.push(ResponseValue);
        }
      }
      debugger;
      console.log(uploadedTableList.value);
    };
    function fileviewer(data) {
      debugger;
      const newTabUrl = data;
      window.open(newTabUrl, "_blank");
    }
    const fileuploadDelete = async (data) => {
      DeletedFileUpload.push(data.Id);
      uploadedTableList.value = uploadedTableList.value.filter(
        (item) => item.fileName != data.fileName
      );
      if (DeletedFileUpload.length > 0 && IsDraftFlag == 1) {
        debugger;
        let result = await StockWOFileUploadServices.DeleteList(
          DeletedFileUpload.join(",")
        );
      }
    };
    return {
      showitemfield,
      ShowItems,
      globalFilterFields,
      filters,
      items,
      headers,
      loading,
      paramValue,
      requestid,
      GetCode,
      handleValues,
      AddItems,
      List,
      RequestIDOnChange,
      LoadRequestID,
      ObjVal,
      IsSubmit,
      showFields,
      IsItemEdit,
      IsItemDelete,
      IsItemDelete1,
      dataItems,
      commonItemProps,
      IsShowByStockTransId,
      closetrigger,
      successpop,
      updatepop,
      IsSubmitQuote,
      ReOrderData,
      ReOrderheaders,
      LoadReOrderLevel,
      selectedProduct,
      ReadyFuntion,
      IsReOrderDelete,
      CopyReorderData,
      AddItemmodel,
      wariningPopup,
      ClosewariningPopup,
      AddSingleConfirmation,
      AddAllConfirmation,
      msgcontent,
      warningmsgcontent,
      confirmval,
      WithoutRateContractTable,
      SuppliersWR,
      SuppliersWOR,
      WORateHeaders,
      TotalGrossCalc,
      WithRateContractTable,
      isfilterSupplier,
      filterSupplierByCategory,
      displayClass,

      IsQuote,
      IsQuoteClose,
      IsPI,
      IsPIClose,
      IsQuoteModel,
      IsPIModel,
      clases,
      requestdropdown,
      requestValue,
      requestidValue,
      onDropdownBlur,
      GetSupplierData,
      requestdata,
      CrystalReportPopup,
      ParameterValues,
      PrintType,
      clearItems,
      handleChangedocument,
      uploadedTableList,
      fileviewer,
      fileuploadDelete,
    };
  },
  created() { },
});
</script>
